import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, from, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { User_info_auth } from '../models/user_info';
import { User } from '../models/user';
import { VariablesGlobales } from '../../shared/variablesGlobales';
import { Profile } from '../models/profile';

import * as CryptoJs  from 'crypto-js';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  public currentUser: BehaviorSubject<User_info_auth> ;
  private prefixe_url = 'auth/password-reset/'
  private SIGELAM_KEY = '8bKy>,3M'

  constructor(
    private http: HttpClient,
    private parametres: VariablesGlobales,
  ) {
    this.currentUser = new BehaviorSubject<User_info_auth>(this._decrypte(localStorage.getItem('currentUser')) as User_info_auth);
  }


  public get currentUserValue(): User_info_auth {
    return this.currentUser.value;
  }

  /******************************** methods for secure storage data user ******************************************* */

  private _crypte(data : Object) : string {
    if(!data)
      return null

    console.log('crypte / key: ', this.SIGELAM_KEY);
    return CryptoJs.AES.encrypt(JSON.stringify(data), this.SIGELAM_KEY).toString();
  }

  private _decrypte(data : string) : Object{
    if(!data)
      return null

    console.log('decrypte / key: ',this.SIGELAM_KEY);
    return JSON.parse(CryptoJs.AES.decrypt(data, this.SIGELAM_KEY).toString(CryptoJs.enc.Utf8));
  }
  ///////////////////////////////////////////////////////////////////////////////

  getCurrentUserInfos() : User_info_auth{
    const data = (this._decrypte(localStorage.getItem('currentUser')) as User_info_auth);
    return data??null
  }

  updateUserInfos(user : User){
    var userAnt = this._decrypte(localStorage.getItem('currentUser')) as User_info_auth;
    userAnt.user = user;
    localStorage.setItem('currentUser', this._crypte(userAnt));
    //console.log(localStorage.getItem('currentUser.user'));
    this.currentUser.next(userAnt);
  }

  updateProfilUserInfos(profil : Profile){
    var userAnt = this._decrypte(localStorage.getItem('currentUser')) as User_info_auth
    userAnt.profile = profil;
    localStorage.setItem('currentUser', this._crypte(userAnt));
    //console.log(localStorage.getItem('currentUser.user'));
    this.currentUser.next(userAnt);
  }

  login(username, password) {
    return this.http.post<any>(this.parametres.URL_API + 'login', { username, password })
        .pipe(map(user => {
          //console.log(user)
            user['profile'] = user.user.profile;
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', this._crypte(user));
            localStorage.setItem('currentLabo', JSON.stringify({logo : user.labo.logo, name : user.labo.nom+" "+user.labo.prenom}));
            this.currentUser.next(user);
            return user;
      }));
  }

  /*
    object : {
      password: string,
      question_id: string,
      verification_string: string,
      session_id: string,
      user_id: string
    }
  */
  activateAccount(object: Object){
    return this.http.post<any>(this.parametres.URL_API + 'verify_user', object)
  }

  removeCurrentUser(){
    localStorage.removeItem('currentUser');
    this.currentUser.next(null);
  }

  logout(session_id, user_id) {
    // remove user from local storage and set current user to null
    this.removeCurrentUser();
    return this.http.post<any>(this.parametres.URL_API + 'logout', { session_id, user_id})
  }

  /**trouve la question d'user en fonction de son pseudo */
  findQuestion(user : any){
    return this.http.post(this.parametres.URL_API + this.prefixe_url + 'discover_user_details', user)
  }
  /**repond a la question */
  sendAnswer(answer : any){
    return this.http.post(this.parametres.URL_API + this.prefixe_url + 'verify_user_string', answer)
  }
  /**repond a la question */
  updatePassword(data : any){
    return this.http.post(this.parametres.URL_API + this.prefixe_url + 'reset_password', data)
  }
}
